import React from 'react';

// Reads <option> children so every existing Form.Select becomes this by changing the tag
// alone -- no call site has to restate its options, its handler, or what it stores.
export const optionsFromChildren = (children) => React.Children.toArray(children)
  .flat(Infinity)
  .filter((child) => React.isValidElement(child) && child.type === 'option')
  .map((child) => {
    const label = React.Children.toArray(child.props.children).join('');
    // A native <option> with no value attribute uses its text as the value.
    const value = child.props.value === undefined ? label : String(child.props.value);
    return { value, label: label || value };
  });
